import { useScrollVisible } from "./useScrollVisible";

export function Contact() {
  const { ref, visible } = useScrollVisible(0.1);

  return (
    <section id="kontakt" className="relative py-24 md:py-32 bg-stone-900 text-sand-100">
      <div ref={ref} className="max-w-6xl mx-auto px-5 lg:px-10">
        <div
          className={`max-w-2xl mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-terra-400" />
            <span className="text-terra-400 text-[11px] tracking-[0.35em] uppercase font-medium">Kontakt</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-sand-50 leading-[1.08] tracking-tight font-semibold">
            Lass uns sprechen.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-20">
          {/* Left — contact details */}
          <div
            className={`transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div className="space-y-5">
              <a href="tel:+497529634259" className="block group">
                <p className="text-[10px] text-terra-400 tracking-[0.3em] uppercase font-medium mb-1">Telefon</p>
                <p className="font-display text-2xl text-sand-50 font-medium group-hover:text-sage-300 transition-colors">
                  07529 / 634259
                </p>
              </a>

              <a href="mailto:mail@zielbalance.de" className="block group">
                <p className="text-[10px] text-terra-400 tracking-[0.3em] uppercase font-medium mb-1">E-Mail</p>
                <p className="font-display text-xl md:text-2xl text-sand-50 font-medium group-hover:text-sage-300 transition-colors break-all">
                  mail@zielbalance.de
                </p>
              </a>

              <div>
                <p className="text-[10px] text-terra-400 tracking-[0.3em] uppercase font-medium mb-1">Adresse</p>
                <p className="font-display text-xl text-sand-50 font-medium leading-snug">
                  Grüntenstr. 3<br />88289 Waldburg
                </p>
              </div>
            </div>

            <a
              href="mailto:mail@zielbalance.de"
              className="mt-9 inline-flex items-center gap-2.5 bg-sand-50 hover:bg-terra-400 text-stone-900 px-7 py-3.5 transition-colors duration-300 font-medium text-sm"
            >
              E-Mail schreiben
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>

          {/* Right — places & availability */}
          <div
            className={`space-y-10 transition-all duration-700 delay-150 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div>
              <p className="text-[10px] text-terra-400 tracking-[0.3em] uppercase font-medium mb-4">Behandlungsorte</p>
              <ul className="space-y-3 text-sand-100/85 font-light text-sm">
                <li className="flex gap-3">
                  <span className="text-terra-400 mt-1">—</span>
                  <span><span className="text-sand-50 font-medium">Bei mir in Waldburg</span> &middot; Grüntenstr. 3</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-terra-400 mt-1">—</span>
                  <span><span className="text-sand-50 font-medium">Bei dir zuhause</span> &middot; in Waldburg und Umgebung</span>
                </li>
              </ul>
            </div>

            <div className="pt-8 border-t border-sand-100/15">
              <p className="text-[10px] text-terra-400 tracking-[0.3em] uppercase font-medium mb-4">Erreichbarkeit</p>
              <div className="space-y-2 text-sm text-sand-100/85 font-light">
                <div className="flex justify-between max-w-xs">
                  <span>Termine</span>
                  <span className="text-sand-50">nach Vereinbarung</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
